import {API_ROOT_URL} from 'envs/_current/config'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'
import {groupSchema} from './schema/organization'

export const group_getGroups_Api = {
  name: 'group_getGroups_Api',
  backend: `Route::get('groups/get', 'GroupController@getGroups');`,
  root: API_ROOT_URL,
  path: '/groups/get',
  method: 'GET',
  paramsFields: ['group_type', 'keyword', 'sort_by'],
  schema: groupSchema,
  transform: createListTransform(groupSchema),
}

export const group_getFeaturedGroups_Api = {
  name: 'group_getFeaturedGroups_Api',
  backend: `Route::get('groups/get-featured', 'GroupController@getFeatured');`,
  root: API_ROOT_URL,
  path: '/groups/get-featured',
  method: 'GET',
  paramsFields: ['group_type'],
  schema: groupSchema,
  transform: createListTransform(groupSchema),
}

export const group_getMyGroups_Api = {
  name: 'group_getMyGroups_Api',
  backend: `Route::get('groups/get-my-groups', 'GroupController@getMyGroups');`,
  root: API_ROOT_URL,
  path: '/groups/get-my-groups',
  method: 'GET',
  paramsFields: ['group_type'],
  schema: groupSchema,
  transform: createListTransform(groupSchema),
}

export const group_getById_Api = {
  name: 'group_getById_Api',
  backend: `Route::get('groups/{id}/get', 'GroupController@getById');`,
  root: API_ROOT_URL,
  path: '/groups/:id/get',
  method: 'GET',
  schema: groupSchema,
  transform: createTransform(groupSchema, 'data'),
}

export const group_create_Api = {
  name: 'group_create_Api',
  backend: `Route::post('groups/create', 'GroupController@create');`,
  root: API_ROOT_URL,
  path: '/groups/create',
  method: 'POST',
  schema: groupSchema,
  transform: createTransform(groupSchema, 'data'),
}

export const group_edit_Api = {
  name: 'group_edit_Api',
  backend: `Route::post('groups/{id}/edit', 'GroupController@edit');`,
  root: API_ROOT_URL,
  path: '/groups/:id/edit',
  method: 'POST',
  schema: groupSchema,
  transform: createTransform(groupSchema, 'data'),
}

export const group_delete_Api = {
  name: 'group_delete_Api',
  backend: `Route::post('groups/{id}/delete', 'GroupController@delete');`,
  root: API_ROOT_URL,
  path: '/groups/:id/delete',
  method: 'POST',
  schema: groupSchema,
  transform: createTransform(groupSchema, 'data'),
}

export const group_joinByCode_Api = {
  name: 'group_joinByCode_Api',
  backend: `Route::post('groups/join-by-code', 'GroupController@joinByCode');`,
  root: API_ROOT_URL,
  path: '/groups/join-by-code',
  method: 'POST',
  schema: groupSchema,
  transform: createTransform(groupSchema, 'data'),
}

export const group_regenerateCode_Api = {
  name: 'group_regenerateCode_Api',
  backend: `Route::post('groups/{id}/regenerate-code', 'GroupController@regenerateCode');`,
  root: API_ROOT_URL,
  path: '/groups/:id/regenerate-code',
  method: 'POST',
}

export const group_getMembers_Api = {
  name: 'group_getMembers_Api',
  backend: `Route::get('groups/{id}/members', 'GroupController@getMembers');`,
  root: API_ROOT_URL,
  path: '/groups/:id/members',
  method: 'GET',
}

export const group_addMember_Api = {
  name: 'group_addMember_Api',
  backend: `Route::post('groups/{id}/add-member', 'GroupController@addMember');`,
  root: API_ROOT_URL,
  path: '/groups/:id/add-member',
  method: 'POST',
}

export const group_editMember_Api = {
  name: 'group_editMember_Api',
  backend: `Route::post('groups/member/{id}/edit', 'GroupController@editMember');`,
  root: API_ROOT_URL,
  path: '/groups/member/:id/edit',
  method: 'POST',
}

export const group_removeMember_Api = {
  name: 'group_removeMember_Api',
  backend: `Route::post('groups/member/{id}/remove', 'GroupController@removeMember');`,
  root: API_ROOT_URL,
  path: '/groups/member/:id/remove',
  method: 'POST',
}

export const group_linkOwner_Api = {
  name: 'group_linkOwner_Api',
  backend: `Route::post('groups/{id}/link-owner', 'GroupController@linkOwner');`,
  root: API_ROOT_URL,
  path: '/groups/:id/link-owner',
  method: 'POST',
}

export const group_unlinkOwner_Api = {
  name: 'group_unlinkOwner_Api',
  backend: `Route::post('groups/owner-link/{id}/unlink', 'GroupController@unlinkOwner');`,
  root: API_ROOT_URL,
  path: '/groups/owner-link/:id/unlink',
  method: 'POST',
}

export const group_getPendingLinks_Api = {
  name: 'group_getPendingLinks_Api',
  backend: `Route::get('groups/owner-link/pending/{owner_type}/{owner_id}', 'GroupController@getPendingLinks');`,
  root: API_ROOT_URL,
  path: '/groups/owner-link/pending/:owner_type/:owner_id',
  method: 'GET',
}

export const group_approveLink_Api = {
  name: 'group_approveLink_Api',
  backend: `Route::post('groups/owner-link/{id}/approve', 'GroupController@approveLink');`,
  root: API_ROOT_URL,
  path: '/groups/owner-link/:id/approve',
  method: 'POST',
}

export const group_denyLink_Api = {
  name: 'group_denyLink_Api',
  backend: `Route::post('groups/owner-link/{id}/deny', 'GroupController@denyLink');`,
  root: API_ROOT_URL,
  path: '/groups/owner-link/:id/deny',
  method: 'POST',
}
